import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=10379a1c&scoped=true&"
import script from "./Post.vue?vue&type=script&lang=js&"
export * from "./Post.vue?vue&type=script&lang=js&"
import style0 from "./Post.vue?vue&type=style&index=0&id=10379a1c&prod&scoped=true&lang=scss&"
import style1 from "./Post.vue?vue&type=style&index=1&id=10379a1c&prod&lang=scss&"
import style2 from "./Post.vue?vue&type=style&index=2&id=10379a1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10379a1c",
  null
  
)

export default component.exports